import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MygroupPage } from './mygroup';

@NgModule({
  declarations: [
    MygroupPage,
  ],
  imports: [
    IonicPageModule.forChild(MygroupPage),
  ],
})
export class MygroupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/mygroup/mygroup.module.ts